const en = {
  nav: {
    dashboard: "Dashboard",
    messages: "Inbox",
    calls: "Calls",
    calendar: "Calendar",
    automations: "Automations",
    marketing: "Marketing",
    orders: "Orders",
    customers: "Customers",
    analytics: "Insights",
    settings: "Settings",
    integrations: "Integrations",
    notifications: "Notifications",
    logout: "Log out",
    products: "Products",
    tasks: "Tasks",
    billing: "Billing",
    support: "Support",
    myBusiness: "My business",
    restaurantEditor: "Restaurant Editor",
    liveRoom: "Live room",
    myProfile: "My Profile",
    team: "Team",
    help: "Help",
    ai: "AI Assistant",
    logs: "Logs",
    alerts: "Alerts",
    whatsapp: "WhatsApp",
  },

  common: {
    loading: "Loading...",
    save: "Save",
    saving: "Saving...",
    saved: "Saved",
    error: "Error",
    openNavigation: "Open navigation",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    search: "Search",
    filter: "Filter",
    actions: "Actions",
    status: "Status",
    type: "Type",
    name: "Name",
    email: "Email",
    phone: "Phone",
    date: "Date",
    total: "Total",
    empty: "No results",
    perPage: "Per page",
    purchases: "Purchases",
    whatsapp: "WhatsApp",
    noData: "No data",
    back: "Back",
    next: "Next",
    previous: "Previous",
    yes: "Yes",
    no: "No",
    confirm: "Confirm",
    close: "Close",
    open: "Open",
    add: "Add",
    remove: "Remove",
    update: "Update",
    creating: "Creating...",
    updating: "Updating...",
    deleting: "Deleting...",
    created: "Created",
    updated: "Updated",
    deleted: "Deleted",
    viewAll: "View all",
    manage: "Manage",
    all: "All",
    manual: "Manual",
    bookings: "Bookings",
    booking: "Booking",
    of: "of",
    page: "Page",
    noResults: "No results",
    view: "View",
    online: "Online",
    offline: "Offline",
    origin: "Origin",
    optional: "optional",
    create: "Create",
    select: "Select",
    filters: "Filters",
  },

  topbar: {
    client: "Client",
    profile: "Profile",
    logout: "Log out",
    defaultClient: "Default",
  },

  status: {
    online: "Online",
    offline: "Offline",
    pending: "Pending",
    completed: "Completed",
    cancelled: "Cancelled",
    processing: "Processing",
    shipped: "Shipped",
    delivered: "Delivered",
    refunded: "Refunded",
    confirmed: "Confirmed",
    paid: "Paid",
    onHold: "On hold",
    failed: "Failed",
    pendingArrival: "On the way 🟠",
    checkedIn: "Checked-in",
    inHouse: "In house",
    checkedOut: "Checked-out",
    noShow: "No Show",
  },

  time: {
    now: "Now",
    minutesAgo: "{{count}}m ago",
    hoursAgo: "{{count}}h ago",
    daysAgo: "{{count}}d ago",
    minutes_short: "m",
    hours_short: "h",
    days_short: "d",
  },

  customers: {
    title: "Customers",
    subtitle: "WhatsApp customers, online store and manually added",
    detail: "Customer detail",
    newCustomer: "New customer",
    editCustomer: "Edit customer",
    backToCustomers: "Back to customers",
    createOffer: "Create offer",
    deleteTitle: "Delete customer?",
    deleteConfirm: "{{name}} will be deleted. This action cannot be undone.",
    thisCustomer: "this customer",
    noName: "No name",
    searchPlaceholder: "Name, email or phone...",
    noResultsWithFilters: "No customers found with the applied filters",
    totalSpent: "Total spent",
    segments: {
      all: "All segments",
      new: "New (≤1 order)",
      recurring: "Recurring (≥2)",
      inactive: "Inactive (+60d)",
      topSpenders: "Top spenders",
      topOrders: "Top orders",
      recent: "Most recent",
    },
    table: {
      name: "Name",
      customer: "Customer",
      contact: "Contact",
      totalSpent: "Total spent",
      orders: "Orders",
      lastActivity: "Last activity",
      actions: "Actions",
      origin: "Origin",
    },
    contactMissing: "No contact info",
    empty: "No customers",
    noBookings: "No bookings",
    perPage: "Per page",
    filters: {
      channel: "Channel",
      date: "Date",
    },
    details: {
      contactInfo: "Contact information",
      orderHistory: "Order history",
      notes: "Notes",
      totalSpent: "Total spent",
      lifetimeValue: "Lifetime value",
      averageOrder: "Average order",
      averageTicket: "Average ticket",
      firstOrder: "First order",
      lastOrder: "Last order",
      lastMessage: "Last message",
      registered: "Registered",
      recentActivity: "Recent activity",
      ordersOrBookings: "Orders/Bookings",
      viewAllOrders: "View all orders",
      note: "Note",
      tags: "Tags",
    },
    placeholders: {
      name: "Mohamed Alami",
      email: "customer@email.com",
      phone: "+212 6XX XXX XXX",
      notes: "Notes about this customer...",
      addTag: "Add tag and press Enter…",
      writeNote: "Write a note about this customer…",
    },
    errors: {
      atLeastOneField: "Add at least name, email or phone",
    },
  },

  orders: {
    title: "Orders",
    detail: "Order detail",
    unifiedDescription: "Unified listing — WooCommerce, Shopify and PrestaShop.",
    searchPlaceholder: "Search #order, customer, email...",
    ordersCount: "orders",
    showing: "Showing",
    loadingDetail: "Loading detail...",
    reminder: "Reminder",
    return: "Return",
    returnType: "Return",
    exchangeType: "Exchange",
    createRequest: "Create request",
    reminderWhat: "What needs to be done?",
    reminderPlaceholder: "Ex: Send order next week",
    reasonPlaceholder: "Describe the reason for the return or exchange...",
    notFound: "Order not found",
    table: {
      order: "Order",
      date: "Date",
      customer: "Customer",
      total: "Total",
      status: "Status",
      items: "Items",
      origin: "Origin",
      actions: "Actions",
      view: "View",
    },
    empty: "No orders",
    perPage: "Per page",
    shipping: "Shipping",
    refundRequest: "Return / exchange request",
    internalNotes: "Internal notes",
    newReminder: "New reminder",
    reminderDateTime: "Date / time (optional)",
    reason: "Reason",
    history: "History",
    purchases: "Purchases",
    totalSpent: "Total spent",
    nameAZ: "Name A-Z",
    filters: {
      allOrders: "All orders",
      pending: "Pending",
      processing: "Processing",
      completed: "Completed",
      cancelled: "Cancelled",
      dateRange: "Date range",
    },
    details: {
      orderInfo: "Order information",
      customerInfo: "Customer information",
      items: "Items",
      shippingAddress: "Shipping address",
      billingAddress: "Billing address",
      paymentMethod: "Payment method",
      shippingMethod: "Shipping method",
      subtotal: "Subtotal",
      shippingCost: "Shipping cost",
      taxes: "Taxes",
      discount: "Discount",
      total: "Total",
    },
    errors: {
      cannotSaveStatus: "Could not save status",
      cannotSaveReminder: "Error saving reminder",
      cannotCreateReturn: "Error creating request",
    },
  },

  dashboard: {
    title: "Dashboard",
    subtitle: "Real-time overview of your business",
    whatsappMessages: "WhatsApp messages",
    totalCustomers: "Total customers",
    recentMessages: "Recent messages",
    latestOrders: "Latest orders",
    latestBookings: "Latest bookings",
    activity: "Activity",
    messages: "Messages",
    runs: "Runs",
    success: "Success",
    contacts: "contacts",
    new: "new",
    people: "people",
    upcoming: "Upcoming",
    appointments: "Appointments",
    bookings: "Bookings",
    patients: "Patients",
    newThisPeriod: "new this period",
    noRecentMessages: "No recent messages",
    noRecentOrders: "No recent orders",
    noRecentBookings: "No recent bookings",
    noText: "(no text)",
    createFirstAutomation: "Create first automation →",
    last7Days: "7 days",
    last30Days: "30 days",
    nucleo: "Nucleo",
    dispatches: "Dispatches",
    totalProcessedEvents: "Total processed events",
    successfulDispatches: "Successful Dispatches",
    matchedStatusDesc: "Dispatches with 'matched' status",
    failedDispatches: "Failed Dispatches",
    errorStatusDesc: "Dispatches with 'error' status",
    skippedDispatches: "Skipped / Duplicates",
    skippedStatusDesc: "Dispatches with 'skipped' status",
    operationalMonitoring: "Operational Monitoring",
    noRecentEvents: "No recent events.",
    aiTrigger: "AI Trigger",
    regexFallback: "Regex Fallback",
    event: "Event",
    crm: {
      title: "CRM",
      contacts: "Contacts",
      newContact: "New Contact",
      searchPlaceholder: "Search by name, phone or email...",
      allStages: "All stages",
      loadingContacts: "Loading contacts...",
      noContactsFound: "No contacts found",
      adjustFilters: "Try adjusting your search filters",
      totalContacts: "Total Contacts",
      openDeals: "Open Deals",
      pipelineValue: "Pipeline Value",
      recentActivity: "Recent Activity",
      segments: "Segments",
      pipelines: "Pipelines",
      customerProfile: "Customer Profile",
      quickView: "CRM Quick View",
      noLinkedContact: "No CRM link",
      linkContactHint: "This chat is not associated with a contact. Link the identity to see metrics and deals.",
      linkContact: "Link Contact",
      aiInsight: "AI Insight",
      analyzingProfile: "Analyzing customer profile...",
      stage: "Stage",
      fastNote: "Fast Note",
      internalNotePlaceholder: "Add internal note...",
      saveNote: "Save",
      viewFullProfile: "View Full Profile",
      lastContact: "Last contact",
      information: "Information",
      phone: "Phone",
      email: "Email",
      company: "Company",
      tags: "Tags",
      editTags: "Edit",
      noTags: "No tags",
      addInternalNote: "Add internal note",
      writeSomething: "Write something about this contact...",
      saving: "Saving...",
      saveNoteBtn: "Save note",
      noActivity: "No activity recorded.",
      timeline: {
        note: "Note",
        message: "Message",
        campaign: "Campaign",
        deal: "Deal",
        booking: "Booking",
        stageChange: "Stage Change",
        system: "System",
        inbound: "Inbound",
        outbound: "Outbound"
      },
      newOpportunity: "New Opportunity",
      deleteContact: "Delete Contact",
      contactNotFound: "Contact Not Found",
      backToCrm: "Back to CRM"
    }
  },

  marketing: {
    newCampaign: "New campaign",
    email: "Email",
    sms: "SMS",
    whatsapp: "WhatsApp",
    social: "Social",
    scheduled: "Scheduled",
    sent: "Sent",
    subtitle: "Templates and campaigns for {{name}}",
    yourBusiness: "your business",
    newTemplate: "New template",
    editTemplate: "Edit template",
    createTemplate: "Create template",
    templateUpdated: "Template updated",
    templateCreated: "Template created",
    templateDeleted: "Template deleted",
    errorDeleting: "Error deleting",
    confirmDelete: "Delete this template?",
    varsHint: "Variables are auto-detected with {{variable}}",
    templateName: "Template name",
    subject: "Subject",
    message: "Message",
    characters: "characters",
    detectedVars: "Detected variables",
    variableLabel: "Label",
    allowReplies: "Allow customer replies",
    launchCampaign: "Launch campaign",
    campaignName: "Campaign name",
    audienceSegment: "Audience segment",
    templateVars: "Template variables",
    preview: "Preview",
    scheduleSend: "Schedule send",
    reach: "Est. reach",
    sendType: "Send type",
    immediate: "Immediate",
    replies: "Replies",
    allowed: "Allowed",
    disabled: "Disabled",
    schedule: "Schedule",
    sendNow: "Send now",
    yours: "Yours",
    campaignLaunched: "Campaign launched to ~{{count}} contacts",
    searchPlaceholder: "Search templates...",
    templates: "templates",
    template: "template",
    loading: "Loading templates...",
    yourTemplates: "Your templates",
    new: "New",
    noOwnTemplates: "No own templates",
    createFirstHint: "Create your first custom template",
    zepelinTemplates: "Zepelin Templates",
    available: "available",
    zepelinTemplatesDesc: "Professional templates created by the Zepelin team. Updated with new holidays and trends. Read-only — use them directly or as a base for yours.",
    segments: {
      all: "All contacts",
      allDesc: "Complete CRM base",
      recent30: "Last 30 days",
      recent30Desc: "Recently created contacts",
      recent90: "Last 90 days",
      recent90Desc: "Quarterly customers",
      withBookings: "With bookings",
      withBookingsDesc: "Have made at least one booking",
      noShow: "No-shows",
      noShowDesc: "Did not show up for their booking",
      vip: "VIP (3+ bookings)",
      vipDesc: "Frequent customers",
    },
    placeholders: {
      emailBody: "Hi {{nombre}},\n\nWe hope you're doing well...",
      whatsappBody: "Hi {{nombre}}, we remind you of your booking for tomorrow at {{hora}}...",
      templateName: "e.g., Dinner booking reminder",
      subject: "Email subject",
    },
    stats: {
      total: "Total contacts",
      withEmail: "With email",
      withPhone: "With phone",
      new30d: "New 30d",
    },
    history: "Campaign History",
    campaignHistory: "Campaign History",
    eligible: "eligible",
    destinatarios: "recipients",
    reach_est: "Est. Reach",
    plantillas: "Templates",
  },

  analytics: {
    title: "Analytics",
    overview: "Overview",
    revenue: "Revenue",
    today: "Today",
    yesterday: "Yesterday",
    noChange: "No change",
    vsPrevious: "vs previous period",
    noDataPeriod: "No data in this period",
    last7Days: "last 7 days",
    last30Days: "last 30 days",
    updating: "Updating...",
    updatedAt: "Updated {{time}}",
    loading: "Loading...",
    "7days": "7 days",
    "30days": "30 days",
    totalMessages: "Total messages",
    messagesSummary: "{{in}} received · {{out}} sent",
    conversations: "Conversations",
    uniqueThreads: "Unique threads",
    newContacts: "New contacts",
    crmTotal: "{{count}} total in CRM",
    confirmedBookings: "Confirmed bookings",
    bookingsSummary: "{{cancelled}} cancelled · {{pending}} pending",
    messageActivity: "Message activity",
    sent: "Sent",
    received: "Received",
    templates: "Templates",
    failed: "Failed",
    estimatedCost: "Estimated cost",
    contactBase: "Contact base",
    withEmail: "With email",
    withPhone: "With phone",
    newThisWeek: "New this week",
    totalCrm: "Total CRM",
    activePlan: "Active plan",
    month: "month",
    noActiveSubscription: "No active subscription",
    voiceBalance: "Voice balance",
    min: "min",
    smsBalance: "SMS balance",
    campaigns: "Campaigns",
    messagingChannels: "Messaging channels",
    bookingStatus: "Booking status",
    noBookings: "No bookings registered",
    totalHistory: "Total history",
  },

  calendar: {
    title: "Calendar",
    loading: "Loading calendar...",
    personalAgenda: "Personal agenda",
    stayManagement: "Stay management",
    consultationManagement: "Consultation management",
    appointmentManagement: "Appointment management",
    bookingManagement: "Booking management",
    weekOf: "Week of",
    more: "more",
    appointmentsThisWeek: "appointments this week",
    newAppointment: "New appointment",
    today: "Today",
    month: "Month",
    week: "Week",
    day: "Day",
    agenda: "Agenda",
    events: "Events",
    newEvent: "New event",
    editEvent: "Edit event",
    deleteEvent: "Delete event",
    eventDetails: "Event details",
    allDay: "All day",
    starts: "Starts",
    ends: "Ends",
    repeat: "Repeat",
    location: "Location",
    description: "Description",
    attendees: "Attendees",
    addAttendee: "Add attendee",
    reminders: "Reminders",
    previous: "Previous",
    next: "Next",
    hour: "Hour",
    addEvent: "Add {{event}}",
    checkin: "Check-in",
    checkout: "Check-out",
    inHouse: "In house",
    roomMap: "Room map",
    freeRoom: "Free room",
    bookedVia: "Booked via",
    createdOn: "Created on",
    deletePermanently: "Delete permanently",
    selectedDay: "Selected day",
    allStatuses: "All statuses",
    active: "Active",
    cancelledNoShow: "Cancelled / No show",
    exportCsv: "Export CSV",
    new: "New",
    ofTheDay: "of the day",
    clickForDetails: "click for details",
    noEventsForDay: "No {{event}}s for this day",
    tablePlaceholder: "Ex: 2 → Table 2",
    startTime: "Start time",
    endTime: "End time",
    duration: "Duration",
    professional: "Professional",
    professionalPlaceholder: "Professional name",
    service: "Service",
    servicePlaceholder: "Manicure, Massage...",
    department: "Department",
    departmentPlaceholder: "Cardiology...",
    doctor: "Doctor",
    doctorPlaceholder: "Dr. Surname",
    patientName: "Patient Name",
    patientPlaceholder: "John Doe",
    clientName: "Client Name",
    clientPlaceholder: "Jane Doe",
    guestName: "Guest Name",
    guestPlaceholder: "Bensouda Family",
    bookingName: "Booking Name",
    bookingPlaceholder: "Birthday reservation",
    editAppointment: "Edit appointment",
    titleSubject: "Title / Subject",
    titlePlaceholder: "Ex: Client meeting, Consultancy...",
    notesPlaceholder: "Any relevant detail...",
    hours: "hours",
    appointment: "appointment",
    room: "Room",
    guests: "guests",
    pax: "Pax",
    tableRoom: "Table/Room",
    start: "Start",
    end: "End",
    title: "Title",
    bookingHistory: "Booking history",
    noBookingsRegistered: "No bookings registered",
    paxShort: "pax",
    table: "Table",
  },

  messages: {
    title: "Messages",
    threads: "Threads",
    noThreads: "No conversations",
    noSubject: "(no subject)",
    selectThread: "Select a thread",
    noMessages: "No messages",
    you: "you",
    contact: "contact",
    typeMessage: "Type a message...",
    send: "Send",
    sending: "Sending...",
    inbox: "Inbox",
    sent: "Sent",
    drafts: "Drafts",
    archived: "Archived",
    spam: "Spam",
    trash: "Trash",
    compose: "Compose",
    reply: "Reply",
    forward: "Forward",
    delete: "Delete",
    markAsRead: "Mark as read",
    markAsUnread: "Mark as unread",
    archive: "Archive",
    search: "Search messages...",
    selectConversation: "Select a conversation",
    attachments: "Attachments",
    messageSent: "Message sent",
    messageFailed: "Message failed to send",
    sendMessage: "Send message",
    sendTemplate: "Send template",
    previews: {
      noMessages: "No recent messages",
      audio: "Audio",
      image: "Image",
      video: "Video",
      location: "Location",
      document: "Document",
      template: "Template",
    },
    header: {
      aiPaused: "🤖 AI paused — manual mode activated",
      aiReactivated: "🤖 AI reactivated",
      aiError: "Error changing AI status",
      resolved: "Resolved",
      reopened: "Reopened",
      archived: "Archived",
      unarchived: "Unarchived",
      addedFromInbox: "Added from inbox",
      contactSaved: "Contact saved",
      saveError: "Error saving",
      addContact: "Add contact",
      editContact: "Edit contact",
      contactNamePlaceholder: "Contact name",
      saveContact: "Save contact",
      conversation: "Conversation",
      reopen: "Reopen",
      resolve: "Resolve",
      unarchive: "Unarchive",
      archive: "Archive",
      pauseAiHint: "Pause AI and reply manually",
      pauseAi: "Pause AI",
      activateAiHint: "Reactivate AI",
      activateAi: "Activate AI",
      closeConversation: "Close conversation",
    },
    input: {
      addDescription: "Add description...",
      fileTooLarge: "is too large",
      attachError: "Error attaching file",
      sendError: "Error sending",
      placeholder: "Type a message...",
    },
    templates: {
      title: "Send WhatsApp Template",
      loading: "Loading templates...",
      none: "No approved templates",
      select: "Select a template",
      variables: "variables",
      change: "Change template",
      variable: "Variable",
      valueFor: "Value for",
      preview: "Preview",
      sent: "Template sent",
      sendError: "Error sending template",
    },
    location: {
      title: "Send location",
      searchPlaceholder: "Search place...",
      useCurrent: "Use my current location",
      gettingLocation: "Getting location...",
      searchError: "Error searching location",
      geoNotAvailable: "Geolocation not available",
      geoError: "Could not get location",
      sent: "Location sent",
      sendError: "Error sending location",
      change: "← Change location",
      map: "Map",
      mapNotAvailable: "Map not available",
      viewOnMaps: "View on Google Maps",
    },
    bubbles: {
      download: "Download",
      tapToDownload: "Tap to download",
      retry: "Retry",
      sharedLocation: "Shared location",
      whatsappTemplate: "WhatsApp Template",
    },
    voice: {
      error: "Could not access microphone",
      recording: "Recording...",
      label: "Record voice message",
    }
  },

  integrations: {
    title: "Integrations",
    subtitle: "Connect your favorite tools and automate your workflows",
    loadingAccount: "Getting account information",
    noActiveSession: "No active session",
    noTenantFound: "No valid tenant found. Please log in again.",
    goToLogin: "Go to login",
    activeTenant: "Active tenant",
    connected: "Connected",
    syncing: "Syncing",
    failed: "Failed",
    searchPlaceholder: "Search integration...",
    noIntegrationsFound: "No integrations found",
    tryDifferentSearch: "Try other search terms or select another category",
    noIntegrationsAvailable: "No integrations available at this time",
    disconnect: "Disconnect",
    disconnectConfirm: "Are you sure you want to disconnect this integration?",
    needIntegration: "Need an integration you can't find?",
    contactUs: "Contact us to develop it",
    configure: "Configure",
    settings: "Settings",
    status: "Status",
    lastSync: "Last sync",
    sync: "Sync",
    syncingStatus: "Syncing...",
    connect: "Connect",
    connecting: "Connecting...",
    disconnecting: "Disconnecting...",
    configureFirst: "Configure first",
    configureIntegration: "Configure {{name}}",
    saveAndConnect: "Save and connect",
    notConnected: "Not connected",
    oauthAuth: "OAuth Authentication",
    credentials: "Credentials",
    secureAuth: "✨ Secure authorization",
    oauthDescription: "Click \"Connect\" and you will be redirected to {{name}} to authorize access.",
    oauthBenefits: {
      noExposure: "✓ No credential exposure",
      secure: "✓ Secure and encrypted",
      revocable: "✓ Revocable at any time",
    },
    noCredentialsRequired: "No additional credentials required.",
    testConnection: "Test Connection",
    connectionSuccessful: "Connection successful. Credentials are valid.",
    connectionError: "Connection error. Verify credentials.",
    networkError: "Network error testing connection",
    invalidCredentials: "Invalid credentials",
    noTenantSelected: "No tenant selected",
    processing: "Processing...",
    reconnect: "Reconnect",
    apiKeys: "API Keys",
    inDevelopment: "Integrations page in development.",
    connectedLabel: "connected",
    totalLabel: "integrations",
    failedLabel: "with error",
    clearSearch: "Clear search",
    available: "Available",
    connectWhatsApp: "Connect WhatsApp",
    showValue: "Show value",
    hideValue: "Hide value",
    officialDocs: "Official documentation",

    woocommerce: {
      oauthRecommended: "OAuth (Recommended)",
      apiKeysAlternative: "API Keys (Alternative)",
      oauthTitle: "Connect with OAuth (1-click)",
      oauthDescription: "You only need your store URL. You will be redirected to WooCommerce to authorize the connection.",
      apiKeysTitle: "Connect with API Keys",
      apiKeysDescription: "Use API Keys if your store doesn't have SSL or you prefer this method.",
      siteUrl: "Store URL",
      consumerKey: "Consumer Key",
      consumerSecret: "Consumer Secret",
    },

    instructions: {
      woocommerce: {
        title: "Connect WooCommerce - Two ways",
        steps: "🔐 OAuth (Recommended):\n• Enter your store URL\n• Click \"Connect\"\n• You will be redirected to WooCommerce to authorize\n\n🔑 API Keys (Alternative):\n• Go to WooCommerce → Settings → Advanced → REST API\n• Create an API key with Read/Write permissions\n• Copy Consumer Key and Consumer Secret",
      },
      shopify: {
        title: "How to connect Shopify",
        steps: "1. Enter your store domain (e.g. your-store.myshopify.com)\n2. Click \"Connect\"\n3. You will be redirected to Shopify\n4. Log in with your admin account\n5. Click \"Install app\" to authorize\n6. Ready! You will be redirected automatically",
      },
      'whatsapp-business': {
        title: "How to get WhatsApp Business credentials",
        steps: "1. Go to https://developers.facebook.com/apps/\n2. Create a \"Business\" type application\n3. Activate the \"WhatsApp\" product\n4. Set up a phone number in \"API Setup\"\n5. Copy the \"Phone Number ID\"\n6. Copy the \"Access Token\" (temporary)",
      },
      stripe: {
        title: "How to get your Stripe key",
        steps: "1. Go to your Stripe dashboard\n2. Go to \"Developers\" → \"API Keys\"\n3. Copy the \"Secret key\" (sk_live_... or sk_test_...)\n4. Paste it in the field below",
      },
      paypal: {
        title: "How to get PayPal credentials",
        steps: "1. Go to https://developer.paypal.com/\n2. Log in with your PayPal account\n3. Go to \"My Apps & Credentials\"\n4. Create a REST API application\n5. Copy the \"Client ID\" and \"Secret\"",
      },
      mailchimp: {
        title: "How to get your Mailchimp API Key",
        steps: "1. Go to your Mailchimp account\n2. Click on your profile picture → \"Account\"\n3. Go to \"Extras\" → \"API Keys\"\n4. Create a new API key\n5. Copy the key and server prefix (e.g. us5)",
      },
      'google-calendar': {
        title: "Connect Google Calendar",
        steps: "1. Click \"Connect\"\n2. You will be redirected to Google\n3. Log in with your Google account\n4. Authorize Calendar permissions\n5. Ready! Your events will sync",
      },
      gmail: {
        title: "Connect Gmail",
        steps: "1. Click \"Connect\"\n2. You will be redirected to Google\n3. Log in with your Google account\n4. Authorize read/write permissions\n5. Ready! Your emails will sync",
      },
    },

    helpLinks: {
      shopify: { shopDomain: "How to find my domain?" },
      woocommerce: {
        siteUrl: "Where is my URL?",
        consumerKey: "How to generate Consumer Key?",
        consumerSecret: "How to generate Consumer Secret?",
      },
      'whatsapp-business': {
        phoneNumberId: "How to get Phone Number ID?",
        accessToken: "How to get Access Token?",
      },
      stripe: { secretKey: "Where is my Secret Key?" },
      paypal: {
        clientId: "Where to find Client ID?",
        secret: "Where to find Secret?",
      },
      mailchimp: {
        apiKey: "How to get API Key?",
        server: "What is Server Prefix?",
      },
      klaviyo: {
        publicKey: "Where is my Public Key?",
        privateKey: "Where is my Private Key?",
      },
      zendesk: {
        subdomain: "What is the subdomain?",
        email: "Which email to use?",
        apiToken: "How to generate API Token?",
      },
      livechat: {
        licenseId: "Where is my License ID?",
        apiKey: "How to get API Key?",
      },
      prestashop: {
        url: "Which URL to use?",
        apiToken: "How to generate API Token?",
      },
      cmi: {
        merchantId: "Contact CMI to get your Merchant ID",
        hmacKey: "They will provide an HMAC Key",
      },
      zapier: { hookUrl: "How to create a webhook in Zapier?" },
    },

    categories: {
      all: "All",
      messaging: "Messaging",
      ecommerce: "eCommerce",
      crm: "CRM",
      productivity: "Productivity",
      payment: "Payments",
      other: "Others",
    },
  },

  settings: {
    title: "Settings",
    subtitle: "Configure your account, business and billing.",

    tabs: {
      company: "Company",
      privacy: "Privacy",
      payments: "Payments",
      billing: "Billing",
      plan: "Plan",
      employees: "Employees",
      business: "Business",
    },

    company: {
      sectionTitle: "Company details",
      panelLanguage: "Panel language",
      name: "Company name",
      rc: "RC",
      ice: "ICE",
      phone: "Phone",
      email: "Email",
      address: "Address",
      website: "Website",
      country: "Business country",
    },

    privacy: {
      usersAccess: "Users & access",
      usersAccessHint: "Control who can access this account.",
      inviteUser: "Invite user",
      invitePlaceholder: "email@example.com",
      role: "Role",
      invite: "Invite",
      email: "Email",
      actions: "Actions",
      remove: "Remove",
      empty: "No users yet.",
      security: "Security",
      force2fa: "Force 2FA",
      disabled: "Disabled",
      requiredAdmins: "Required for Admin/Owner",
      requiredAll: "Required for everyone",
      sessionExpiry: "Session expiry",
      days7: "7 days",
      days30: "30 days",
      days90: "90 days",
      resetPasswords: "Reset passwords",
      sendReset: "Send reset emails",
      recommended2fa: "Recommended: enforce 2FA at least for Admin/Owner.",
      loadingUser: "Loading user...",
      cannotIdentifyTenant: "Could not identify tenant",
      changePassword: "Change password",
      currentPassword: "Current password",
      newPassword: "New password",
      confirmPassword: "Confirm password",
      allFieldsRequired: "All fields are required",
      passwordsDontMatch: "New passwords don't match",
      passwordTooShort: "Password must be at least 6 characters",
      passwordUpdated: "Password updated successfully!",
      noInvitePermission: "You don't have permission to invite new members.",
      upgradePlan: "Upgrade your plan",
    },

    payments: {
      method: "Payment method",
      openPortal: "Open secure portal",
      desc: "Manage card and billing in a secure portal (PCI DSS) — e.g. Stripe Customer Portal.",
      currentMethod: "Current method",
      holder: "Holder",
      loadingTenant: "Loading tenant information...",
      errorOpeningPortal: "Error opening portal",
      noPortalUrl: "No portal URL received",
      noPaymentMethods: "No payment methods configured",
      default: "Default",
      expires: "Expires",
      manageInStripe: "Manage in Stripe",
    },

    billing: {
      history: "Invoice history",
      none: "No invoices yet.",
      count: "Invoices",
    },

    plan: {
      current: "Your current plan",
      plan: "Plan",
      minutes: "Minutes used (month)",
      renewal: "Renewal",
      loadingUser: "Loading user...",
      noAuthenticatedUser: "No authenticated user",
      userHasNoTenant: "User has no assigned tenant",
      cannotIdentifyTenant: "Could not identify tenant",
      errorCreatingCheckout: "Error creating checkout",
      noCheckoutUrl: "No checkout URL received",
      errorOpeningPortal: "Error opening portal",
      noPortalUrl: "No portal URL received",
      subscriptionUpdated: "Subscription updated correctly!",
      currentPlan: "Current",
      manage: "Manage",
      price: "Price",
      available: "Available plans",
      select: "Select",
      noPlan: "You don't have any active plan.",
    },

    employees: {
      manage: "Manage employees",
      name: "Name",
      position: "Position",
      phone: "Phone",
      add: "Add",
      actions: "Actions",
      delete: "Delete",
      empty: "No employees yet.",
    },

    business: {
      params: "Business parameters",
      type: "Business type (key)",
      category: "Category / Subtype (key)",
      timezone: "Timezone",
      tables: "Number of tables",
      capacity: "Capacity (people)",
      applyAll: "Apply to all",
      hours: "Hours",
      open: "Open",
      opensAt: "Opens",
      closesAt: "Closes",
    },
  },

  dow: {
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    sun: "Sun",
  },

  business: {
    type: {
      restaurant: "Restaurant",
      cafe: "Cafe",
      bar: "Bar / Nightlife",
      hotel: "Hotel",
      spa: "Spa",
      clinic: "Clinic",
      salon: "Salon / Beauty",
      gym: "Gym",
      retail: "Retail / Store",
      ecommerce: "eCommerce",
      services: "Services",
      real_estate: "Real estate",
      other: "Other",
    },
  },

  ai: {
    title: "AI Assistant",
    settings: "AI Configuration",
    context: "Business context",
    restaurantProfile: "Restaurant profile",
    voiceAssistant: "Voice assistant",
    fileUpload: "File upload",
    messages: "Conversations",
    training: "Training",
    suggestions: "Suggestions",
    generate: "Generate",
    regenerating: "Regenerating...",
    prompt: "Prompt",
    response: "Response",
    copy: "Copy",
    copied: "Copied",
    unblockAI: "Unblock AI",
    blockAI: "Block AI",
    blockedManually: "Blocked manually",
  },

  restaurant: {
    editor: "Restaurant Editor",
    loading: "Loading restaurant data...",
    readOnly: "Read only",
    lastSaved: "Last saved",
    editMode: "Edit mode",
    preview: "Preview",
    profilePreview: "Profile preview",
    saveChanges: "Save changes",
    notSpecified: "Not specified",
    cuisineType: "Cuisine type",
    checkInPerson: "Check in person",
    liveRoom: "Live room",
    soon: "SOON",
    inRoom: "IN ROOM",
    newCustomer: "New customer",
    assignTable: "Assign table",
    waitlist: "Waitlist",
    addToWaitlist: "Add to waitlist",
    noFreeTables: "No free tables for {{pax}} people",
    view: "view",
    list: "List",
    map: "Map",
    swipeHint: "Tables · swipe ← → to change status",
    upcoming: "Upcoming",
    noUpcomingBookings: "No upcoming bookings",
    tapToMarkArrival: "Tap to mark arrival",
    hotTables: "Hot tables",
    emptyList: "Empty list",
    noActivity: "No activity",
    table: "Table",
    general: "General",
    location: "Location",
    schedule: "Schedule",
    tables: "Tables",
    features: "Features",
    celebrations: "Celebrations",
    menu: "Menu",
    policies: "Policies",
    publish: "Publish",
    unpublish: "Unpublish",
    published: "Published",
    draft: "Draft",
    capacity: "Capacity",
    combinable: "Combinable",
    zones: "Zones",

    status: {
      free: "Free",
      reserved: "Reserved",
      occupied: "Occupied",
      cleaning: "Cleaning",
    },

    errors: {
      cannotResolveTenant: "Could not resolve current tenant.",
      loginAgain: "Log in again and try once more.",
    },

    generalSection: {
      title: "General Information",
      name: "Restaurant name",
      namePlaceholder: "Ex: El Rincón Restaurant",
      phone: "Phone",
      phonePlaceholder: "+212 600 000000",
      email: "Email",
      emailPlaceholder: "info@restaurant.com",
      founded: "Founded year",
      foundedPlaceholder: "1998",
      capacity: "Capacity",
      capacityPlaceholder: "80",
      description: "Description",
      descriptionPlaceholder: "Describe the restaurant, its history and proposal...",
      social: "Social networks",
      facebookPlaceholder: "facebook.com/...",
      instagramPlaceholder: "@user",
      xPlaceholder: "@user",
      classification: "Classification",
      cuisine: "Cuisine type",
      dietary: "Dietary options",
      ambience: "Ambience",
      specialties: "Chef specialties",
      certifications: "Certifications",
      owner: "Owner / Chef",
      ownerName: "Name",
      ownerNamePlaceholder: "Ex: John Doe",
      ownerBio: "Biography",
      ownerBioPlaceholder: "Chef's history...",
      funFacts: "Anecdotes and curiosities",
      funFactsPlaceholder: "Ex: The secret recipe has been in the family for over 50 years...",
    },

    certifications: {
      halal: "Halal",
      organic: "Organic",
      sustainable: "Sustainable",
      michelin: "Michelin",
      glutenFree: "Gluten Free",
      vegan: "Vegan",
      vegetarian: "Vegetarian",
    },

    schedule: {
      venueHours: "Venue hours",
      copyMonday: "Copy Monday to all",
      closed: "Closed",
      morning: "Morning / Midday",
      evening: "Afternoon / Night",
      notApplicable: "Not applicable",
      kitchenHours: "Kitchen hours",
      closedKitchen: "Closed",
      mealServices: "Meal services",
      breakfast: "Breakfast",
      brunch: "Brunch",
      lunch: "Lunch",
      dinner: "Dinner",
      lateNight: "After hours",
      twoDinnerShifts: "Two dinner shifts",
      firstShift: "1st shift",
      secondShift: "2nd shift",
      holidays: "Holidays and special closures",
      noHolidays: "No holidays configured",
      holidayReason: "Reason (Christmas, Ramadan...)",
      seasonalHours: "Seasonal hours",
      summer: "Summer",
      winter: "Winter",
      ramadan: "Ramadan",
    },

    features: {
      venueFeatures: "Venue features",
      accessibility: "Accessibility",
      services: "Services",
      paymentMethods: "Payment methods",
      soundEnvironment: "Sound environment",
      hasBackgroundMusic: "Has background music",
      mainGenres: "Main genres",
      volumeLevel: "Usual volume level",
      liveMusic: "Live music",
      frequency: "Frequency",
      liveMusicTypes: "Live music types",
      approximateSchedule: "Approximate schedule",
      schedulePlaceholder: "Ex: Friday and Saturday 20:00-23:00",
      atmosphere: "Atmosphere and climate",
      roomTemperature: "Room temperature",
      climateSystem: "Climate system",
      lighting: "Lighting ambience",
      outdoorSeating: "Outdoor seating",
      heatedTerrace: "Heated terrace",
      fans: "Fans",
      entertainment: "Entertainment",
      sustainability: "Sustainability",
      technology: "Technology",

      volumeLevels: {
        quiet: "Low / conversation",
        medium: "Medium",
        loud: "Loud",
      },
      frequencies: {
        daily: "Daily",
        weekends: "Weekends",
        weekly: "Once a week",
        occasional: "Occasional / special events",
      },
      temperature: {
        cold: "Cold (strong AC)",
        comfortable: "Comfortable (21-23°C)",
        warm: "Warm (heating)",
        variable: "Variable by zone",
      },
      climateSystem: {
        ac: "Air conditioning",
        heating: "Heating",
        both: "Both",
        natural: "Natural ventilation only",
      },
      lighting: {
        bright: "Bright lighting",
        ambient: "Ambient light",
        dim: "Dim light / romantic",
        adjustable: "Adjustable by zone",
      },
      techItems: {
        qrMenus: "QR Menus",
        ownApp: "Own App",
        nfcPayment: "NFC Payments",
        digitalWaitlist: "Digital waitlist",
      },
    },

    celebrations: {
      title: "Celebrations and special events",
      birthdayCake: "Birthday cake",
      price: "Price",
      numberOfPeople: "Number of people",
      specialPackages: "Special packages",
      addPackage: "Add package",
      noPackages: "No packages configured",
      packageName: "Package name",
      packageDescription: "Package description",
      description: "Description",
      options: {
        birthday: "Birthday",
        anniversary: "Anniversary",
        engagement: "Engagement",
        business: "Business meeting",
        graduation: "Graduation",
        other: "Others",
      },
    },

    menu: {
      importWithAI: "Import menu with AI",
      importDescription: "Import your menu from a PDF, photo, Word or Excel. AI will automatically extract categories, dishes, prices and allergens.",
      supportedFormats: "Supported formats: PDF, JPG, PNG, DOCX, XLSX · Max. 10MB",
      processing: "Processing...",
      importMenu: "Import menu",
      ocrHint: "OCR import will detect language automatically and AI will normalize names and prices.",
      categories: "Categories",
      newCategory: "New category",
      editCategory: "Edit category",
      noCategories: "No categories. Create one or import your menu.",
      categoryNamePlaceholder: "Ex: Starters, Meats, Desserts...",
      categoryDescriptionPlaceholder: "Optional category description",
      categoryUpdated: "Category updated",
      categoryCreated: "Category created",
      categoryDeleted: "Category deleted",
      confirmDeleteCategory: "Delete this category and all its dishes?",
      dishes: "Dishes",
      newDish: "New dish",
      editDish: "Edit dish",
      loadingDishes: "Loading dishes...",
      noDishes: "No dishes in this category.",
      dishName: "Dish name",
      dishNamePlaceholder: "Ex: Caesar Salad",
      dishDescriptionPlaceholder: "Main ingredients, preparation...",
      category: "Category",
      noCategory: "No category",
      preparationTime: "Preparation (min)",
      calories: "Calories (kcal)",
      dietaryOptions: "Dietary options",
      dishUpdated: "Dish updated",
      dishCreated: "Dish created",
      dishDeleted: "Dish deleted",
      confirmDeleteDish: "Delete this dish?",
      processingError: "Error processing file",
      importError: "Error importing",
      menuImported: "Menu imported: {{categories}} categories, {{items}} dishes",
      unnamed: "Unnamed",

      dietary: {
        vegetarian: "Vegetarian",
        vegan: "Vegan",
        glutenFree: "Gluten free",
        spicy: "Spicy",
      },

      allergens: {
        title: "Allergens",
        gluten: "Gluten",
        crustaceans: "Crustaceans",
        eggs: "Eggs",
        fish: "Fish",
        peanuts: "Peanuts",
        soy: "Soy",
        dairy: "Dairy",
        nuts: "Nuts",
        celery: "Celery",
        mustard: "Mustard",
        sesame: "Sesame",
        sulfites: "Sulfites",
        lupin: "Lupin",
        mollusks: "Mollusks",
      },
    },

    policies: {
      bookingPolicies: "Booking policies",
      cancellationHours: "Cancellation — hours before",
      noShowPenalty: "No-show penalty (%)",
      deposit: "Deposit",
      perPerson: "Per person",
      tableHoldTime: "Table hold time (min)",
      restrictions: "Restrictions",
      minorsAllowed: "Minors allowed",
      minorsAccompanied: "Accompanied minors",
      adultsOnly: "Adults only (+18)",
      petsAllowed: "Pets allowed",
      serviceAnimals: "Service animals",
      smokingArea: "Smoking area",
      smokingTerrace: "Smoking terrace",
      dressCode: "Dress code",
      groupsWelcome: "Groups welcome",
      dressCodeTitle: "Dress code",
      dressCodeType: "Code type",
      noDressCode: "No specific code",
      casual: "Casual / Informal",
      smartCasual: "Smart Casual",
      elegante: "Elegant",
      formal: "Formal (suit)",
      traditional: "Traditional",
      dressCodePlaceholder: "Ex: Elegant attire required, gentlemen with jacket...",
      groupPolicies: "Group policies",
      minGroupSize: "Min. group size",
      advanceNotice: "Advance notice (hours)",
      specialGroupPolicy: "Special group policy",
      specialGroupPolicyPlaceholder: "Ex: Set menu required, 30% deposit...",
      children: "Children",
      kidsMenu: "Kids menu",
      notAvailable: "Not available",
      available: "Available",
      customizable: "Customizable menu",
      childAgeLimit: "Child age limit (years)",
      highChairs: "High chairs available",
      changingTable: "Changing table in bathrooms",
      playArea: "Play area",
      pets: "Pets",
      petPolicy: "Pet policy",
      noPets: "No pets allowed",
      serviceAnimalsOnly: "Service animals only",
      teraceOnly: "Terrace only",
      allAllowed: "Allowed throughout the venue",
      waterBowl: "Water bowl available",
      treats: "Pet treats",
      health: "Health",
      masksRequired: "Masks required",
      vaccinationRequired: "Vaccination required",
      maxCapacity: "Max capacity",
      capacityPlaceholder: "Ex: 50",
      inclusivity: "Inclusivity",
      lgbtqFriendly: "LGBTQ+ friendly",
      accessibleAll: "Accessible for all",
      diversityStatement: "Diversity statement",
      diversityPlaceholder: "Ex: We welcome everyone regardless of...",
      legalTerms: "Legal terms",
      privacyPolicy: "Privacy policy (URL or text)",
      privacyPlaceholder: "https://... or policy text",
      termsAndConditions: "Terms and conditions",
      termsPlaceholder: "Booking terms and conditions...",
      gdprCompliant: "GDPR compliant",
    },
  },

  automations: {
    title: "Automations",
    subtitle: "Connect events with automatic actions without code.",
    newAutomation: "New automation",
    new: "New",
    active: "Active",
    inactive: "Inactive",
    test: "Test",
    testing: "Testing...",
    testSuccess: "Test executed correctly ✅",
    testError: "Error in test",
    noAutomations: "No automations",
    noAutomationsDesc: "Create your first automation or use a template to get started quickly.",
    viewTemplates: "View templates",
    createFromScratch: "Create from scratch",
    generateWithAI: "Generate with AI",
    use: "Use",
    deleteTitle: "Delete automation?",
    deleteConfirm: "This action cannot be undone.",
    when: "WHEN",
    before: "before",
    delay: "delay",
    addStep: "Add step",
    selectTrigger: "Select the event that triggers this automation:",
    whenThisHappens: "When this happens...",
    executeTheseActions: "Execute these actions:",
    requiresTimeConfig: "Requires time configuration",
    willSend: "Will send",
    beforeBooking: "before booking",
    ofWait: "wait",
    automationName: "Automation name",
    clickToInsert: "Click a variable to insert it:",
    example: "Example",

    categories: {
      ecommerce: "E-commerce",
      bookings: "Bookings",
      messages: "Messages",
      crm: "CRM",
      marketing: "Marketing",
      advanced: "Advanced",
      control: "Control",
    },

    triggers: {
      newOrderWoo: "New order (WooCommerce)",
      newOrderWooDesc: "Triggers when a new order is received in your store.",
      orderUpdatedWoo: "Order updated (WooCommerce)",
      orderUpdatedWooDesc: "Triggers when an existing order status changes.",
      bookingReminder: "Booking reminder",
      bookingReminderDesc: "Sends a notification to the customer before their booking.",
      newBookingConfirmed: "New booking confirmed",
      newBookingConfirmedDesc: "Triggers when a new booking is created in the system.",
      newWhatsAppMessage: "New WhatsApp message",
      newWhatsAppMessageDesc: "Triggers when a customer sends a WhatsApp message.",
      incomingWebhook: "Incoming webhook",
      incomingWebhookDesc: "Triggers when you receive an external HTTP request.",
      crmContactCreated: "Contact created",
      crmContactCreatedDesc: "Triggers when a new contact is created in the CRM.",
      crmContactUpdated: "Contact updated",
      crmContactUpdatedDesc: "Triggers when any contact data is updated.",
      crmLifecycleChanged: "Lifecycle stage changed",
      crmLifecycleChangedDesc: "Triggers when a contact's lifecycle stage changes.",
      crmDealCreated: "Deal created",
      crmDealCreatedDesc: "Triggers when a new sales deal is created.",
      crmDealStageChanged: "Deal stage changed",
      crmDealStageChangedDesc: "Triggers when a deal moves to a different stage.",
      crmNoteCreated: "Note created",
      crmNoteCreatedDesc: "Triggers when a manual note is added to a contact.",
    },

    variables: {
      orderId: "Order number",
      orderTotal: "Order total",
      orderStatus: "Order status",
      newStatus: "New status",
      customerName: "Customer name",
      customerPhone: "Customer phone",
      customerEmail: "Customer email",
      productNames: "Order products",
      phone: "Phone",
      bookingDate: "Booking date",
      bookingTime: "Booking time",
      time: "Time",
      people: "Number of people",
      reference: "Reference",
      messageText: "Message text",
      webhookData: "Webhook data",
      contactId: "Contact ID",
      dealId: "Deal ID",
      oldStage: "Old stage",
      newStage: "New stage",
      noteBody: "Note content",
      tagName: "Tag name",
    },

    fields: {
      sendBefore: "Send how far in advance",
      timeUnit: "Time unit",
      templateName: "Template name",
      language: "Language",
      jsonBody: "JSON Body (optional)",
      wait: "Wait",
      unit: "Unit",
    },

    units: {
      minutesBefore: "Minutes before",
      hoursBefore: "Hours before",
      daysBefore: "Days before",
      minutes: "Minutes",
      hours: "Hours",
      days: "Days",
      short: {
        minutes: "min",
        hours: "h",
        days: "d",
      },
    },

    languages: {
      spanish: "Spanish",
      french: "French",
      english: "English",
      arabic: "Arabic",
    },

    actions: {
      sendWhatsApp: "Send WhatsApp message",
      sendWhatsAppDesc: "Sends a free text message via WhatsApp.",
      sendTemplate: "Send template",
      sendTemplateDesc: "Sends an official WhatsApp template.",
      crmAddTag: "Add tag",
      crmAddTagDesc: "Adds a specific tag to the contact.",
      crmSetLifecycle: "Change lifecycle stage",
      crmSetLifecycleDesc: "Changes the contact's lifecycle stage (Lead, Customer, etc.).",
      crmAddNote: "Add note",
      crmAddNoteDesc: "Adds an internal note to the contact's timeline.",
      crmCreateDeal: "Create deal",
      crmCreateDealDesc: "Creates a new sales deal associated with the contact.",
      mktSendTemplate: "Send Marketing template",
      mktSendTemplateDesc: "Sends a marketing template via the preferred channel.",
      callExternalUrl: "Call external URL",
      callExternalUrlDesc: "Makes an HTTP POST request to an external endpoint.",
      wait: "Wait for some time",
      waitDesc: "Pauses X minutes/hours/days before the next action",
    },

    placeholders: {
      example2: "Ex: 2",
      example7: "Ex: 7",
      messageExample: "Ex: Hi {{customer_name}}! We remind you of your booking on {{booking_date}} at {{booking_time}} ✅",
    },

    templates: {
      title: "Automation templates",
      orderConfirmation: "Order confirmation",
      orderConfirmationDesc: "When a new order arrives, send automatic confirmation via WhatsApp.",
      reminder2h: "Booking reminder 2h before",
      reminder2hDesc: "Notifies the customer 2 hours before their booking.",
      reminder1d: "Booking reminder 1 day before",
      reminder1dDesc: "Notifies the customer the day before their booking.",
      orderShipped: "Order shipped → WhatsApp notice",
      orderShippedDesc: "When an order status changes to \"processing\", notify the customer.",
      review7d: "Review 7 days after order",
      review7dDesc: "Request a rating one week after purchase.",
    },

    templateMessages: {
      orderConfirmation: "Hi {{customer_name}}! 🎉\n\nWe have received your order {{order_id}}.\n\n🛍️ Products: {{product_names}}\n💰 Total: {{order_total}}\n\nWe will notify you when it's on its way. Thanks for your purchase!",
      reminder2h: "Hi {{customer_name}}! 👋\n\nWe remind you of your booking today at *{{booking_time}}* for {{people}} people.\n\nIf you need to change anything, reply to this message.\n\nSee you soon! 🍽️",
      reminder1d: "Hi {{customer_name}}! 😊\n\nWe remind you that tomorrow *{{booking_date}}* you have a booking at *{{booking_time}}* for {{people}} people.\n\nRef: {{reference}}\n\nNeed to cancel or change? Write us here.",
      orderShipped: "Hi {{customer_name}}! 📦\n\nYour order {{order_id}} is being prepared.\nSoon you will receive more information about shipping.",
      review7d: "Hi {{customer_name}}! ⭐\n\nWe hope you are enjoying your order {{order_id}}.\n\nCould you leave us a review? Your opinion helps us a lot. Thanks!",
    },

    errors: {
      selectTrigger: "Select a trigger",
      addAtLeastOneAction: "Add at least one action (not just a delay)",
      configureReminder: "Configure the reminder advance (amount and unit)",
      saveFailed: "Error saving",
      unknownError: "Unknown error",
      saveFirst: "Save the automation first",
    },

    aiAssistant: "AI Assistant",
    aiDescription: "Describe your automation in natural language",
    aiWhatToAutomate: "What do you want to automate?",
    aiPlaceholder: "Ex: Send a WhatsApp to the customer 7 days after their order asking for a review...",
    aiEnterHint: "Press Enter to generate · Shift+Enter for new line",
    aiExampleRequests: "Example requests",
    aiGenerating: "Generating...",
    aiProcessing: "Mistral is processing your request",
    aiGenerated: "Automation generated",
    aiReviewHint: "Review the generated message and adjust it before activating the automation.",
    aiNewRequest: "New request",
    aiUseThis: "Use this automation",
    aiGenerate: "Generate",

    aiSuggestions: {
      confirmation: "Send WhatsApp confirmation when a new order arrives",
      reminder2h: "Remind the customer of the booking 2 hours before",
      review7d: "Ask for a review 7 days after the order",
      processing: "Notify the customer when their order status changes to \"processing\"",
      welcome: "Welcome message when a new WhatsApp message arrives",
      reminder1d: "Booking reminder the day before",
    },

    aiErrors: {
      generationFailed: "Error generating the automation",
      connectionError: "Connection error. Check that the server is active.",
    },

    waitDays: "Wait {{count}} day(s)",
    waitHours: "Wait {{count}} hour(s)",
    waitMinutes: "Wait {{count}} minute(s)",
  },

  freelance: {
    manager: "Freelance manager",
    profile: "My profile",
    availability: "Availability",
    services: "Services",
    media: "Media",
    schedule: "Schedule",
    general: "General",
    physicalCharacteristics: "Physical characteristics",
    chat: "Chat",
    preview: "Preview",
  },


  products: {
    title: "Products",
    all: "All products",
    active: "Active",
    inactive: "Inactive",
    outOfStock: "Out of stock",
    lowStock: "Low stock",
    categories: "Categories",
    price: "Price",
    stock: "Stock",
    sku: "SKU",
    variants: "Variants",
    attributes: "Attributes",
    description: "Description",
    images: "Images",
    addProduct: "Add product",
    editProduct: "Edit product",
  },

  billing: {
    title: "Billing",
    invoices: "Invoices",
    paymentMethods: "Payment methods",
    subscription: "Subscription",
    currentPlan: "Current plan",
    changePlan: "Change plan",
    cancelPlan: "Cancel plan",
    billingHistory: "Billing history",
    downloadInvoice: "Download invoice",
    amount: "Amount",
    date: "Date",
    status: "Status",
    paid: "Paid",
    unpaid: "Unpaid",
    overdue: "Overdue",
  },

  support: {
    contactSupport: "Contact support",
    submitTicket: "Submit ticket",
    ticketHistory: "Ticket history",
    faq: "FAQ",
    chat: "Live chat",
    email: "Support email",
    phone: "Support phone",
    priority: "Priority",
    low: "Low",
    medium: "Medium",
    high: "High",
    urgent: "Urgent",
    subject: "Subject",
    message: "Message",
    attachments: "Attachments",
    submit: "Submit",
    submitted: "Submitted",
  },

  notifications: {
    title: "Notifications",
    all: "All",
    unread: "Unread",
    markAllRead: "Mark all as read",
    clearAll: "Clear all",
    empty: "No notifications",
    settings: "Notification settings",
    emailNotifications: "Email notifications",
    pushNotifications: "Push notifications",
    sound: "Sound",
    desktop: "Desktop",
    mobile: "Mobile",
  },

  calls: {
    title: "Calls",
    calls: "Calls",
    searchPlaceholder: "Search by ID, number or intent...",
    reset: "Reset",
    intent: "Intent",
    table: {
      id: "ID",
      from: "From",
      to: "To",
      duration: "Duration",
      toLabel: "To",
    },
    intents: {
      booking: "Booking",
      menu: "Menu",
      complaint: "Complaint",
      schedule: "Schedule",
      location: "Location",
      payment: "Payment",
      menuLetter: "Menu letter",
    },
    status: {
      ok: "OK",
      ongoing: "Ongoing",
      failed: "Failed",
    },
    comingSoon: {
      title: "AI Calls",
      description: "This section will be available soon. You will be able to see, filter and analyze all your calls managed by AI.",
      badge: "Coming soon",
    },
    call: "Call",
    detailSubtitle: "Summary and transcript of the call.",
    backToList: "Back to calls",
    participants: "Participants",
    audio: "Audio",
    download: "Download",
    noAudio: "No audio available for this call.",
    transcript: "Transcript",
    assistant: "Assistant",
    user: "User",
    metadata: "Metadata",
    processedMeta: "Processed STT→GPT→TTS: ~620ms",
    audioQuality: "Audio quality: 8k μ-law",
    detectedLanguage: "Detected language: en/es",
  },

  errors: {
    somethingWentWrong: "Something went wrong",
    tryAgain: "Try again",
    pageNotFound: "Page not found",
    unauthorized: "Unauthorized",
    forbidden: "Forbidden",
    serverError: "Server error",
    networkError: "Network error",
    validationError: "Validation error",
    required: "This field is required",
    invalidEmail: "Invalid email",
    invalidPhone: "Invalid phone",
    minLength: "Minimum {{min}} characters",
    maxLength: "Maximum {{max}} characters",
    passwordMismatch: "Passwords don't match",
    tenantNotFound: "Could not identify tenant. Please reload.",
  },
} as const;

export default en;
